<template>
  <div class="subcategories">
    <div v-for="(objectGroup, index) of mainCategory.subcategoryGroups" :key="index" class="subcategories__group">
      <div class="subcategories__group__subcategory">
        <SubcategoryGroup :subcategory-group="objectGroup" :father-category-id="mainCategory.idAux || 0" />
      </div>
      <div class="subcategories__group__h-separator" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerSubcategories',
  components: {
    // BCheckbox: async () => {
    //   const { BCheckbox } = await import('buefy/dist/esm/checkbox');
    //   return BCheckbox;
    // },
    SubcategoryGroup: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerSubcategoryGroup'),
  },
  props: {
    availableSubcategories: {
      type: Array,
      default: () => [],
    },
    mainCategory: {
      type: Object,
      default: () => ({
        subcategoryGroups: [],
      }),
    },
  },
  data() {
    return {
      arraySubcategoryGroups: [
        {
          arraySubcategories: [
            {
              stringName: 'Fuera del área',
              booleanIsSelected: false,
              id: 100,
            },
            {
              stringName: 'Dentro del área',
              booleanIsSelected: false,
              id: 100,
            },
          ],
        },
        {
          arraySubcategories: [
            {
              stringName: 'Fuera del área',
              booleanIsSelected: false,
              id: 100,
            },
            {
              stringName: 'Dentro del área',
              booleanIsSelected: false,
              id: 100,
            },
          ],
        },
        {
          arraySubcategories: [
            {
              stringName: 'Fuera del área',
              booleanIsSelected: false,
              id: 100,
            },
            {
              stringName: 'Dentro del área',
              booleanIsSelected: false,
              id: 100,
            },
          ],
        },
        {
          arraySubcategories: [
            {
              stringName: 'Fuera del área',
              booleanIsSelected: false,
              id: 100,
            },
            {
              stringName: 'Dentro del área',
              booleanIsSelected: false,
              id: 100,
            },
          ],
        },
        {
          arraySubcategories: [
            {
              stringName: 'Fuera del área',
              booleanIsSelected: false,
              id: 100,
            },
            {
              stringName: 'Dentro del área',
              booleanIsSelected: false,
              id: 100,
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.subcategories {
  width: 100%;
  height: 238px;
  overflow: auto;
  border-radius: 4px;
  border: solid 1px #ccd6dd;
  background-color: #fff;
  padding: 12px 9px;

  &__group {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &__subcategory {
      width: 100%;
      text-align: left;
      padding-left: 0.5em;
    }

    &__h-separator {
      width: 100%;
      height: 1px;
      border-bottom: dashed 1px #cbd0d4;
      margin-bottom: 0.5em;
    }

    &:last-child {
      & .subcategories__group__h-separator {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.subcategories__group {
  & span.control-label {
    font-family: Roboto-Regular, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.97;
    letter-spacing: -0.12px;
    text-align: center;
    color: #1d220f;
    margin-left: 0.8em;
  }

  & .b-checkbox.checkbox:hover input[type='checkbox']:not(:disabled) + .check {
    border-color: #9bd73a;
  }

  & .b-checkbox.checkbox input[type='checkbox']:checked + .check {
    background: #9bd73a
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E")
      no-repeat center center;
    border-color: #9bd73a;
  }
}
</style>
